import './ShowcaseSkeleton.css';

import avatarPlaceholder from '@static/vectors/placeholders/avatar-placeholder.svg';
import videoPlaceholder from '@static/vectors/placeholders/video-placeholder.svg';

export default function ShowcaseSkeleton() {
	const skeletons = Array(4).fill(null);

	return (
		<section id="demos-showcase-skeleton">
			{skeletons.map((_, index) => (
				<article key={index} className="skeleton-card">
					<section className="thumbnail-wrapper">
						<img className="image-placeholder avatar-blink" src={videoPlaceholder} alt="" />
					</section>
					<section className="content-wrapper">
						<div className="channel-data">
							<span className="skeleton-element circle" />
							<img src={avatarPlaceholder} alt="" className="avatar-blink" />
							<span className="skeleton-element short-text" />
						</div>
						<div className="description-lines">
							<span className="skeleton-element text-line" />
							<span className="skeleton-element text-line" />
							<span className="skeleton-element text-line half" />
						</div>
						<div className="skeleton-element button-shape" />
					</section>
				</article>
			))}
		</section>
	);
}
